import { Accordion } from './vanilla-js/accordion/Accordion';
import { BurgerMenu } from './vanilla-js/burger-menu/BurgerMenu';
import { Carousel } from './vanilla-js/carousel/Carousel';
import { FilterDropdown } from './vanilla-js/dropdown/FilterDropdown';
import { SmoothScroller } from './vanilla-js/smooth-scroller/SmoothScroller';
import { VideoDropdown } from './vanilla-js/dropdown/VideoDropdown';
import { VideoSelector } from './vanilla-js/video-selector/VideoSelector';

/**
 * Build objects that will load the class in.
 *
 * vanillaJs object properties
 * @param {Object} class - The imported class
 * @param {string} target - The css class selector to target
 * @param {bool} multi - Define if there be multiple instances of the target class
 */

const vanillaJs = {
  accordion: {
    class: Accordion,
    target: '.accordion',
    multi: true,
  },
  burgerMenu: {
    class: BurgerMenu,
    target: '.sih-navigation__burger-menu-button',
    multi: false,
  },
  carousel: {
    class: Carousel,
    target: '.student-reviews__swiper',
    multi: false,
    args: [
      {
        loop: true,
        speed: 1200,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 6500,
          disableOnInteraction: false,
        },
      },
    ],
  },
  FilterDropdown: {
    class: FilterDropdown,
    target: '.custom-dropdown.filter-dropdown',
    multi: false,
  },
  smoothScroller: {
    class: SmoothScroller,
    target: 'a[href*="#"]',
    multi: false,
    args: [{ speed: 500 }],
  },
  VideoDropdown: {
    class: VideoDropdown,
    target: '.custom-dropdown.video-dropdown',
    multi: false,
  },
  VideoSelector: {
    class: VideoSelector,
    target: '.videos__video-selection-wrapper',
    multi: false,
  },
};

const keys = Object.keys(vanillaJs);

const initVanillaJs = () => {
  keys.forEach((key) => {
    if (!!vanillaJs[key].args) {
      new vanillaJs[key].class(
        vanillaJs[key].target,
        vanillaJs[key].multi,
        ...vanillaJs[key].args
      );
    } else {
      new vanillaJs[key].class(vanillaJs[key].target, vanillaJs[key].multi);
    }
  });
};

if (window.addEventListener) {
  window.addEventListener('load', initVanillaJs);
} else if (window.attachEvent) {
  window.attachEvent('onload', initVanillaJs);
} else {
  window.onload = initVanillaJs;
}
